<template>
</template>

<script>
export default {
  name: "Error",
  props: ["error"],
  mounted() {
    this.$swal.fire({
      icon: "error",
      title: "Oops...",
      timer: 3500,
      text: this.error,
      showConfirmButton: false
    });
  },
};

</script>